import React from 'react';
import { Section, SectionHeading } from './Shared';
const points = ['Llegas sin saber qué serie prescribir', 'Improvisas, sin un protocolo que te respalde', 'Absorbes la carga energética del paciente', 'Armas cada sesión desde cero', 'Sin ficha clínica ni continuidad', 'Pacientes que no regresan'];
export const PainPoints = () => <Section className="max-w-4xl" data-id="element-184" data-mp="2bvoe3v0w81tp">
    <SectionHeading eyebrow="El punto de partida" className="mb-7" data-id="element-185" data-mp="1xxzqifffygky">
      ¿Cuántas sesiones más vas a improvisar sin un sistema clínico?
    </SectionHeading>

    <div className="relative max-w-2xl mx-auto mb-9 overflow-hidden rounded-3xl border border-brand-gold/50 bg-brand-greenSage/25 px-6 py-8 sm:px-10 text-center shadow-[0_18px_40px_-28px_rgba(46,40,32,0.6)]" data-id="element-186" data-mp="220o04pbzbriz">
      {/* Warm, living decor */}
      <span aria-hidden="true" className="pointer-events-none absolute -top-3 -left-2 text-5xl opacity-40 animate-float-soft select-none" data-id="element-187" data-mp="3idup0n4u25ia">
        🪴
      </span>
      <span aria-hidden="true" className="pointer-events-none absolute -bottom-4 -right-1 text-5xl opacity-40 animate-float-soft select-none" style={{
      animationDelay: '1.4s'
    }} data-id="element-188" data-mp="1z0oqolqjbjdn">
        🌿
      </span>
      <span aria-hidden="true" className="pointer-events-none absolute top-4 right-6 text-2xl opacity-40 animate-float-soft select-none" style={{
      animationDelay: '2.2s'
    }} data-id="element-189" data-mp="27t8ltc7mb5tq">
        🍵
      </span>
      <span aria-hidden="true" className="pointer-events-none absolute bottom-5 left-6 text-2xl opacity-35 animate-float-soft select-none" style={{
      animationDelay: '0.8s'
    }} data-id="element-190" data-mp="1g2cf6tc5hxew">
        🕯️
      </span>

      <div className="relative" data-id="element-191" data-mp="1k3e70p3qn76u">
        <span aria-hidden="true" className="inline-flex items-center justify-center w-11 h-11 rounded-full bg-brand-paper border border-brand-gold/50 text-xl mb-4" data-id="element-192" data-mp="1k34pzr0o8ada">
          🤍
        </span>
        <p className="font-display text-lg sm:text-2xl leading-snug text-brand-purpleDark" data-id="element-193" data-mp="2vhru3rqo3ilt">
          Saber Chi Kung no es lo mismo que tener un{' '}
          <span className="relative inline-block" data-id="element-194" data-mp="1y3zrl5390cdy">
            <span aria-hidden="true" className="absolute inset-x-[-3px] bottom-[0.08em] h-[0.32em] bg-brand-goldLight/70" data-id="element-195" data-mp="1y2on131zb0ls" />
            <span className="relative font-semibold" data-id="element-196" data-mp="275g017ai64fj">sistema clínico</span>
          </span>{' '}
          para aplicarlo con autoridad profesional.
        </p>
        <p className="mt-3 font-display italic text-base sm:text-lg text-brand-burgundy" data-id="element-197" data-mp="1acko38zqjp14">
          Y esa diferencia se siente en cada consulta. 🌱
        </p>
      </div>
    </div>

    <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2.5 max-w-3xl mx-auto mb-8" data-id="element-198" data-mp="1je0wjb6zph2p">
      {points.map(point => <li key={point} className="flex items-start gap-2.5" data-id="element-199" data-mp="1o7wo9vwnu7pf">
          <span aria-hidden="true" className="mt-2 w-1.5 h-1.5 rotate-45 bg-brand-burgundy shrink-0" data-id="element-200" data-mp="qq526d4w8193" />
          <span className="text-brand-text text-sm" data-id="element-201" data-mp="o68e307m11ki">{point}</span>
        </li>)}
    </ul>

    <p className="text-center text-xl md:text-2xl font-display font-semibold purple-gradient-text" data-id="element-202" data-mp="o3vyuut8l5b5">
      ¿Y si esta fuera la última sesión que trabajas así?
    </p>
  </Section>;